import { cn } from "@/lib/utils";

export default function NotificationCircle({
  className = "",
}: {
  className?: string;
}) {
  return (
    <span
      className={cn(
        "absolute w-[0.58rem] h-[0.58rem] bg-[#CF0202] rounded-full pointer-events-none border-[0.07rem] border-black",
        className
      )}
    />
  );
}
